// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---Fmy_m","changedRecordsList":"changedRecordsList---ALt3C","changedRecord":"changedRecord---XbPt9"};